import Cookies, { CookieAttributes } from 'js-cookie';
import { WEBID_KEY, envRegion } from './constants';
import * as logger from '@/utils/logger';
import { mergeUUID } from '@/utils/utils';
import { func } from 'prop-types';
interface InjectWebId {
  (): any;
  doing?: boolean;
}

/**
 * 之前引入了fingerprintjs为异步引入，现去掉了fingerprintjs，暂时改为同步引入自实现
 * 基于海外风险数据收敛的临时方案，可能后边还会调整方案
 * 在初始化SDK时，立即注入
 */
let WEB_ID = InjectWebId();

function InjectWebId() {
  let webid = Cookies.get(WEBID_KEY);
  if (!webid || !webid.startsWith('verify_')) {
    webid = setWebidCookie();
  }
  return webid;
}

export function setWebidCookie(verify_fp?: string) {
  const start_time = Date.now();
  let webid = verify_fp || mergeUUID();
  const fpCookieOption =
    typeof window.fpCookieOption === 'object' ? window.fpCookieOption : {};
  const cookieOption: CookieAttributes = {
    path: '/',
    ...fpCookieOption,
  };
  if (envRegion === 'cn') {
    cookieOption.expires = 60;
  }
  if (
    !(
      fpCookieOption.domain &&
      /^([a-z0-9-]+)?(\.[a-z0-9-]+)+$/.test(fpCookieOption.domain)
    )
  ) {
    delete cookieOption.domain;
  }
  Cookies.remove(WEBID_KEY, { path: '/' }); // 使用决策透传的 cookie 前，先删除之前的没有配置参数的 cookie ，新的 cookie 会根据 fpCookieOption 的参数设置。
  Cookies.set(WEBID_KEY, webid, cookieOption);
  let fp = Cookies.get(WEBID_KEY);
  if (!fp) {
    // 如果验证码在 iframe 中，不设置 sameSite none; secure 会种不上 cookie
    Cookies.set(WEBID_KEY, webid, {
      ...cookieOption,
      secure: true,
      sameSite: 'none',
    });
    fp = Cookies.get(WEBID_KEY);
  }
  let msg =
    webid && fp ? '' : !webid ? 'generate fp failed' : 'set cookie failed';
  logger.trackEvent('fp_set_cookie', {
    duration: Date.now() - start_time,
    is_success: !msg ? 1 : 0,
    msg,
    product_host: window.location.host,
    product_path: window.location.pathname,
  });
  return fp;
}

/**
 * 在弹出验证码时，设备指纹种cookie
 */
export default async function (verify_fp?: string) {
  // 业务方如果是直接通过verify_data透传fp，以透传的fp为准，需要替换本地生成的fp
  let isTouChuanFp = verify_fp && verify_fp !== WEB_ID;
  if (isTouChuanFp) {
    WEB_ID = setWebidCookie(verify_fp);
  }
  return WEB_ID;
}
